import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalMap from '../shared/components/modal-map/modal-map.view.html';
import modalProductComment from './product-comment-modal/product-comment-modal.view.html';
import modalCreateTemplate from './create-template-modal/create-template-modal.view.html';
import modalLogistic from './modal-logistic/modal-logistic.view.html';
import modalCartComment from './modal-comment-cart/modal-comment-cart.view.html';
import { inherits } from 'util';

let inject = [
    '$scope',
    'CartService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    'ngAuthSettings',
    'SessionService',
    '$timeout',
    '$mdToast',
    '$mdDialog',
    '$filter',
    '$window'
];

class CartController {
    constructor($scope, CartService, $state, $rootScope, SharedService, $uibModal, ngAuthSettings, SessionService, $timeout, $mdToast, $mdDialog, $filter, $window) {
        this.$state = $state;
        this.ngAuthSettings = ngAuthSettings;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.SessionService = SessionService;
        this.CartService = CartService;
        this.SharedService = SharedService;
        this.loanding = false;
        this.orderDataForm = {
            country: '',
            state: '',
            city: '',
            shipping: '',
            payment: '',
            comment: '',
            clientPriceList: '',
            deliveryDay: '',
            workingHours: ''
        };
        this.quoteCartSeller = {
            realOrderInfo: {},
            realQuoteInfo: {}
        };
        this.orderDataForm.locationsByFastSearch = [];
        this.orderDataForm.locationSelected = false;
        this.orderDataForm.searchLocationtext = '';
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = false;
        this.orderDataForm.errorLoadingLocationsByFastSearch = false;
        this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
        this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
        this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
        this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
        this.quoteCartSeller.totalItemsQuoteValueSeller = 0;
        this.pesoTotalCanasta = 0;
        this.cantidadTotalCanasta = 0;
        this.updatingCityLocation = false;
        this.updatedCityLocation = false;
        this.errorUpdatingCityLocation = false;
        this.pointsOfSaleData = [];
        this.pointOfSaleId = '';
        this.currentPointOfSale = '';
        this.loadingPointsOfSale = false;
        this.loadedPointsOfSale = false;
        this.savingPayMethodCart = false;
        this.errorUpdatingPayMethod = false;
        this.addingQuantityItemCart = false;
        this.addedQuantityItemCart = false;
        this.errorAddingQuantityItemtoCart = false;
        this.errorMessageAddingQuantityItemtoCart = '';
        this.errorMessagesAddingQuantityItemtoCart = '';
        this.coupon = {};
        this.coupon.savingCoupon = false;
        this.coupon.savedCoupon = false;
        this.coupon.validCoupon = false;
        this.coupon.code = false;
        this.orderDataForm.loadingCartInfo = true;
        this.orderDataForm.loadedCartInfo = false;
        this.loadedPayMethods = false;
        this.loadMethodSend = true;

        this.showOnlyCitiesInTransportRule = 0;

        this.disabledWorkingHours = false;
        this.validateChangeTotalCartItems = false;

        this.cart = {};
        this.modalidadEnvio = {};

        this.popup2 = {
            opened: false
        };
        this.fechaMinima = "";
        this.fechaMaxima = "";
        this.inizializarDatePiker();

        this.$rootScope.$on('onUpdateCart', (event, arg) => {
            this.updateCart();
        });

        this.CartService.getMethodTransport().then(response => {
            this.showOnlyCitiesInTransportRule = (response.valor == 1) ? 0 : 1;
        });

        this.festive = [
          '2019-08-07',
          '2019-08-19',
          '2019-10-14',
          '2019-11-04',
          '2019-11-11',
          '2019-12-25'
        ];

    }

    $onInit() {

        let cartId = this.SessionService.get('cartId') || '';
        let cartUnified = this.SessionService.get('cartUnified');

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        let clientPriceListName = '';
        try {
            clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
        } catch (e) {
        }


        let tunnelCity = this.SessionService.get('tunnelCity');

        if(tunnelCity){

            if (cartId && tunnelCity) {
                this.CartService.updateCityLocation({
                    'cartId': cartId,
                    'cityLocationId': tunnelCity.location.cityId
                }).then(response => {
                    this.updatingCityLocation = false;
                    this.updatedCityLocation = false;
                    if (response.error) {
                        this.errorUpdatingCityLocation = true;
                    }
                }).catch(reason => {
                    this.updatingCityLocation = false;
                    this.updatedCityLocation = true;
                    this.errorUpdatingCityLocation = true;
                });

            }
        }

        // this.getModalidadEnvio(userId, cartId)
        this.CartService.getCart(cartId, userId, clientPriceListName, true).then(response => {
            this.cart = response;
            this.shCtrl.cart = response;
            this.Products = [];
            if (response.itemsCanastaUsuario.length) {
              response.itemsCanastaUsuario.forEach((valFor) => {
                this.Products.push(
                  {
                    "id": valFor.id,
                    "name": valFor.name,
                    "price": valFor.price,
                    "category": valFor.category.slug,
                    "quantity": valFor.quantity,
                  }
                )
              });
            }
            this.$window.dataLayer.push({
              'event': 'checkout',
              'ecommerce': {
                'checkout': {
                  'actionField': {'step': 1},
                  'products': this.Products
                }
              }
            });

            if(this.cart.cartOrderData.payment.id){
              this.orderDataForm.payment = this.cart.cartOrderData.payment.id.toString();
            }
            this.getAllCartOrderInfo();
            // Get the bill resume
            try {
                if (this.shCtrl.globals.currentClient.third) {
                    this.getInfoBillfoldState();
                }
            }
            catch (e) {
            }
        }).catch(() => {
            this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
            $('html, body').animate({
                'scrollTop': 0
            }, 2);
        });

        if (__env.adaptative) {
            angular.element(document).ready(function () {
                $('html, body').animate({
                    'scrollTop': 0
                }, 2);
            });
        }


    }

    disabled(data) {
        var date = data.date,
            mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }
    decreaseProductQuantity(product) {
        if (product.quantityToAddFromCart > 1)
            product.quantityToAddFromCart--;
        this.saveItemQuantity(product);

    }

    increaseProductQuantity(product) {
        product.quantityToAddFromCart++;
        this.saveItemQuantity(product);
    }

    getAllCartOrderInfo() {
        this.orderDataForm.loadingCartInfo = true;
        this.orderDataForm.loadedCartIfno = false;
        let cart = angular.copy(this.shCtrl.cart);
        let cartId = this.SessionService.get('cartId') || '';
        if (cart) {
            let sellerId = '';
            try {
                sellerId = this.shCtrl.globals.currentUser.sellerId;
            }
            catch (e) {
            }

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }

            this.CartService.getPayMethods(sellerId, userId,cartId).then(response => {
                if (!this.orderDataForm.pointOfSaleId) {
                    this.loadedPayMethods = true;
                    this.payMethods = response;

                }
                this.CartService.getPointsOfSale().then(response2 => {
                    if (!this.orderDataForm.pointOfSaleId) {
                        this.loadedPointsOfSale = true;
                        this.pointsOfSaleData = response2.operatingCenters;
                    }
                    this.$timeout(() => {
                        // Set the default Point of Sale
                        let pointOfSaleId = '';
                        try {
                            pointOfSaleId = this.shCtrl.cart.order.pointOfSale.id;
                        } catch (e) {

                        }

                        if (pointOfSaleId) {
                            this.orderDataForm.pointOfSaleId = pointOfSaleId.toString();
                            this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
                        }
                        else if (this.pointsOfSaleData.length > 0) {
                            this.orderDataForm.pointOfSaleId = this.pointsOfSaleData[0].id.toString();
                            this.setCurrentPointOfSale(this.orderDataForm.pointOfSaleId);
                        }

                        if (!this.orderDataForm.shipping && this.shCtrl.cart.order.shippingId) {

                            this.orderDataForm.shipping = this.shCtrl.cart.order.shippingId.toString();

                            this.changeAvailableDay(this.orderDataForm.shipping);
                        }
                        if (!this.orderComment && this.shCtrl.cart.order.comment) {
                            this.orderComment = this.shCtrl.cart.order.comment.toString();
                        }
                        if (!this.orderDataForm.comment && this.shCtrl.cart.order.comment) {
                            this.orderDataForm.comment = this.shCtrl.cart.order.comment.toString();
                        }

                        if (!this.orderDataForm.payment && this.SessionService.get('tunnelPayMethod')) {
                            this.orderDataForm.payment = this.SessionService.get('tunnelPayMethod');
                        }
                        if (!this.orderDataForm.workingHours && this.shCtrl.cart.order.workingHours) {
                            this.orderDataForm.workingHours = this.shCtrl.cart.order.workingHours;
                        }
                        // console.log("holllaaaa",this.shCtrl.cart)
                        if (!this.orderDataForm.deliveryDay && this.shCtrl.cart.order.deliveryDay) {
                            let date = new Date(this.shCtrl.cart.order.deliveryDay)
                            this.orderDataForm.deliveryDay = date;
                            this.orderDataForm.city = this.shCtrl.cart.order.location.city.id;
                            //console.log("el date");
                            //console.log(this.orderDataForm.deliveryDay);

                            if(date.getDay() == 5){
                                this.orderDataForm.workingHours = "am";
                                this.disabledWorkingHours = true;
                                this.saveWorkingHours(this.orderDataForm.workingHours);
                            }else if(!this.shCtrl.cart.order.workingHours){
                                this.orderDataForm.workingHours = "";
                                this.disabledWorkingHours = false;
                                this.saveWorkingHours(this.orderDataForm.workingHours);
                            }
                        }


                        // Set the city
                        try {
                            if (this.SessionService.get('tunnelCity')) {
                                this.orderDataForm.city = this.SessionService.get('tunnelCity').location.cityId;
                                this.orderDataForm.state = this.SessionService.get('tunnelCity').location.stateId;
                                this.orderDataForm.country = this.SessionService.get('tunnelCity').location.countryId;
                                this.orderDataForm.searchLocationtext = this.SessionService.get('tunnelCity').location.fullName;
                            }
                        }
                        catch (e) { }
                    }, 1000);
                }).catch(reason => {

                });
            }).catch(reason => {

            });
        }
        this.orderDataForm.loadingCartInfo = false;
        this.orderDataForm.loadedCartInfo = true;

    }

    getInfoBillfoldState() {

        try {
            this.loadingBillResume = true;
            let thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
            let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
            this.CartService.getInfoBillfoldState(
                thirdDocumentNumber,
                branchCode
            )
                .then(billfoldResume => {
                    this.billfoldResume = billfoldResume;
                    this.loadingBillResume = false;
                    this.loadedBillResume = true;
                    this.lastUpdatedBillResume = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                })
                .catch(error => {
                    this.loadingBillResume = false;
                });

        }
        catch (e) {
            // ...
        }
    }

    buyNow(form, allowGuestInTunnel) {

        if (this.orderDataForm.payment) {
            this.SessionService.put('tunnelPayMethod', this.orderDataForm.payment);
            this.$window.dataLayer.push({
              'event': 'checkoutOption',
              'ecommerce': {
                'checkout_option': {
                  'actionField': {'step': 1, 'option': this.orderDataForm.payment.toString()}
                }
              }
            });
          //console.log(this.orderDataForm.payment);

        }

        if (this.orderDataForm.city) {
          //console.log("city");
            this.SessionService.put('tunnelCity', {
                location: {
                    cityId: this.orderDataForm.city,
                    stateId: this.orderDataForm.state,
                    countryId: this.orderDataForm.country,
                    fullName: this.orderDataForm.searchLocationtext
                }
            });
        }


        if (allowGuestInTunnel === 'register') {
            this.$state.go('home.login');
            return;
        }
        this.$rootScope.allowGuestInTunnel = allowGuestInTunnel || 0;
        this.showAllCartErrors = false;
        //console.log(form);
        if (form.$valid) {

            if (this.cart) {
                let itemWithOutStock = this.cart.items.filter(value => {
                    if (value.quantity > value.cantidad) {
                        return value;
                    }
                });
                if (itemWithOutStock.length) {
                    let cartItemHtml = '';
                    itemWithOutStock.forEach(val => {
                        cartItemHtml += `
              <li>
                <strong>- Producto: </strong> ${val.name} -
                <strong>Cantidad: </strong>${val.cantidad} Unidades
              </li>`;
                    });
                    let mensaje = `
            <span>Lo Sentimos, Algunos productos exceden la cantidad dispobible<strong>
            <ul>
              ${cartItemHtml}
            </ul>
            Por favor elimine el excedente.</span>`;
                    let options = {
                        title: 'Cantidad no disponible',
                        isHtml: true,
                        content: mensaje,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    return this.messageResponse(options);
                }
            }
            if (this.cart.cartId) {
                this.savingOrderCart = true;
                this.savedOrderCart = false;
                this.errorSavingOrderCart = false;
                this.orderDataForm.cartId = this.cart.cartId;
                this.orderDataForm.userId = '';
                this.orderDataForm.sellerId = '';
                try {
                    this.orderDataForm.userId = this.shCtrl.globals.currentUser.userId;
                }
                catch (e) {
                }
                try {
                    this.orderDataForm.sellerId = this.shCtrl.globals.currentUser.sellerId;
                }
                catch (e) {
                }
                this.CartService.saveCartOrderData(this.orderDataForm).then(response => {
                    this.savingOrderCart = false;
                    if (!response.error) {
                        this.savedOrderCart = true;
                        this.shCtrl.globals.currentUser.city = this.orderDataForm.city;
                        this.SessionService.put("currentUser", this.shCtrl.globals.currentUser);
                        this.orderDataForm.comment = '';
                        this.$state.go('home.tunnel');
                    } else {
                        let errorMessageSavingOrderCart = response.message;
                        this.errorSavingOrderCart = true;
                        let messageTitle = response.errorCode === 'EVMP' ? 'El pedido no puede ser procesado' : 'Debes diligenciar algunos datos aún...';
                        let options = {
                            title: messageTitle,
                            isHtml: true,
                            content: errorMessageSavingOrderCart,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    this.savingOrderCart = false;
                    this.savedOrderCart = false;
                    this.errorSavingOrderCart = true;
                    let options = {
                        title: '',
                        isHtml: false,
                        content: 'Ha ocurrido un error al actualizar la informacion del carrito',
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        } else {

            this.showAllCartErrors = true;
            //console.log("formulario Errores", form.$error);
            angular.forEach(form.$error.required, field => {
                field.$setDirty();
            });
            if (!this.orderForm.searchLocationtext) this.orderForm.searchLocationtext = {};
            if (!this.orderForm.payment) this.orderForm.payment = {};
            if (!this.orderForm.clientPriceList) this.orderForm.clientPriceList = {};
            if (!this.orderForm.workingHours) this.orderForm.workingHours = {};
            if (!this.orderForm.shipping) this.orderForm.shipping = {};
            let contentDynamic = '';
            //console.log(this.orderForm.searchLocationtext.$invalid);
            if (this.orderForm.searchLocationtext.$invalid && !this.orderForm.searchLocationtext.$pristine || !this.orderDataForm.city) {
                contentDynamic = `
          <li>
            Seleccione la Ciudad.
          </li>`;
            }

            if (this.orderForm.payment.$invalid && !this.orderForm.payment.$pristine) {
                contentDynamic += `
          <li>
            Seleccione el medio de pago.
          </li>`;
            }

            try {
                if (this.orderForm.deliveryDay.$invalid && !this.orderForm.deliveryDay.$pristine) {
                    contentDynamic += `
              <li>
                Seleccione la fecha de entrega.
              </li>`;
                }

            }
            catch (e) {
            }
            
            if (this.orderForm.shipping.$invalid && !this.orderForm.shipping.$pristine) {
                contentDynamic += `
              <li>
                Seleccione el tipo de envio.
              </li>`;
            }
            console.log(this.orderForm);
            if (this.orderForm.workingHours.$invalid && !this.orderForm.workingHours.$pristine) {
                contentDynamic += `
              <li>
                Seleccione la jornada de entrega.
              </li>`;
            }
            if (this.orderForm.clientPriceList.$invalid && !this.orderForm.clientPriceList.$pristine) {
                contentDynamic += `
          <li>
            Seleccione la lista de precios a aplicar al cliente.
          </li>`;
            }
            let options = {
                title: 'Faltan algunos datos por diligenciar...',
                isHtml: true,
                content: `
          <div>
            <p>
              Para continuar con este proceso debes diligenciar los siguientes datos:
            </p>
            <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
              ${contentDynamic}
            </ul>
          </div>
        `,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        }
    }

    showProductComment(item) {
        let modal_options = this.$uibModal.open({
            animation: true,
            template: modalProductComment,
            controller: 'ProductCommentModalController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => item
            }
        });
        modal_options.result.then(() => {

        }).catch(reason => {

        });
    }

    getLocationsByFastSearch(searchLocationText) {
        this.orderDataForm.locationSelected = false;
        this.orderDataForm.locationsByFastSearch = [];
        this.orderDataForm.locationSelected = false;
        this.orderDataForm.country = '';
        this.orderDataForm.state = '';
        this.orderDataForm.city = '';
        this.orderDataForm.loadingLocationsByFastSearh = false;
        this.orderDataForm.loadedLocationsByFastSearch = false;
        this.orderDataForm.errorLoadingLocationsByFastSearch = false;
        if (searchLocationText.length > 3) {
            this.orderDataForm.loadingLocationsByFastSearh = true;
            this.CartService.locationBySearchText({
                'searchText': searchLocationText,
                'showOnlyValidCountries': 1,
                'showOnlyCitiesInTransportRule': this.showOnlyCitiesInTransportRule
            }).then(response => {
                this.orderDataForm.loadingLocationsByFastSearh = false;
                this.orderDataForm.loadedLocationsByFastSearch = true;
                this.orderDataForm.locationsByFastSearch = response;
            }).catch(reason => {
                this.orderDataForm.loadingLocationsByFastSearh = false;
                this.orderDataForm.loadedLocationsByFastSearch = true;
                this.orderDataForm.errorLoadingLocationsByFastSearch = true;
            });
        }
    }

    setLocationCity(location) {
        this.orderDataForm.country = location.countryId;
        this.orderDataForm.state = location.stateId;
        this.orderDataForm.city = location.cityId;

        this.orderDataForm.locationSelected = true;
        this.orderDataForm.searchLocationtext = location.cityName + ', ' +
            location.stateName + ' - ' +
            location.countryName;
        this.updateCityLocation();
    }

    updateValuesQuoteSeller() {
        if (!this.orderDataForm.clientPriceList) {
            try {
                this.orderDataForm.clientPriceList = this.SessionService.get('quoteCartSeller').clientPriceList;
            }
            catch (e) {
            }

            if (!this.orderDataForm.clientPriceList) {
                this.orderDataForm.clientPriceList = 'client';
            }
        }
        this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
        this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
        this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
        this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
        this.quoteCartSeller.totalItemsQuoteValueSeller = 0;

        let realOrderInfo = {
            subtotal: 0,
            iva: 0,
            discount: 0,
            transport: 0,
            total: 0
        };

        let realQuoteInfo = {
            subtotal: 0,
            iva: 0,
            discount: 0,
            transport: 0,
            total: 0
        };
        if (this.shCtrl.globals.currentUser.isSeller) {
            // Se actualiza la informacion de los precios
            let itemsQuoteCartSeller = [];
            let priceListName = this.orderDataForm.clientPriceList;

            let subtotal = 0;
            let taxes = 0;
            let discounts = 0;
            let total = 0;
            this.cart.items.forEach((item, key) => {
                try {
                    // Item data
                    let itemId = item.id;
                    let itemQuantity = item.quantity;
                    let itemUnitValue = item.priceItemQuoteSeller;
                    let itemQuantityValue = item.quantity * item.priceItemQuoteSeller;
                    let itemTaxPercent = item.ivaPercentageQuoteSeller;
                    let itemDiscountPercent = item.discountPercentageItemQuoteSeller;
                    // Some verifications
                    if (isNaN(itemDiscountPercent) || itemDiscountPercent < 0 || itemDiscountPercent > 100) {
                        item.discountPercentageItemQuoteSeller = 0;
                        itemDiscountPercent = 0
                    }
                    else if (priceListName === 'client' && itemDiscountPercent > item.maxDiscount) {
                        item.discountPercentageItemQuoteSeller = item.maxDiscount;
                        itemDiscountPercent = item.maxDiscount;
                    }
                    else if (priceListName === 'cost' && itemDiscountPercent > 100) {
                        item.discountPercentageItemQuoteSeller = 100;
                        itemDiscountPercent = 100;
                    }

                    // Item values
                    let itemSubtotal = itemQuantityValue;
                    let itemDiscount = 0;

                    if (priceListName === 'client') {
                        itemDiscount = itemQuantityValue * itemDiscountPercent / 100;
                    }
                    if (priceListName === 'cost') {
                        itemDiscount = itemQuantityValue / ((100 - itemDiscountPercent) / 100);
                        itemDiscount = itemDiscount - itemQuantityValue;
                    }
                    // Discount or Profit?
                    let itemQuantityValueWithDiscount = 0;
                    if (priceListName === 'client') {
                        itemQuantityValueWithDiscount = itemQuantityValue - itemDiscount;
                    }
                    if (priceListName === 'cost') {
                        itemQuantityValueWithDiscount = itemQuantityValue + itemDiscount;
                    }
                    let itemTax = itemQuantityValueWithDiscount * itemTaxPercent / 100;
                    let itemTotal = itemQuantityValueWithDiscount + itemTax;

                    // Totals
                    subtotal += itemQuantityValue;
                    discounts += itemDiscount;
                    taxes += itemTax;
                    total += itemTotal;

                    // Update the item total model
                    this.cart.items[key].totalItemCartSeller = itemTotal;

                    // ========================================================================================================================
                    // Real quote values
                    // ========================================================================================================================
                    if (item.quote) {
                        realQuoteInfo.subtotal += itemQuantityValue;
                        realQuoteInfo.iva += itemTax;
                        realQuoteInfo.discount += itemDiscount;
                        if (priceListName === 'client') {
                            realQuoteInfo.total = realQuoteInfo.subtotal - realQuoteInfo.discount + realQuoteInfo.iva;
                        }
                        else if (priceListName === 'cost') {
                            realQuoteInfo.total = realQuoteInfo.subtotal + realQuoteInfo.discount + realQuoteInfo.iva;
                        }
                    }
                    // ========================================================================================================================
                    // Real order values
                    // ========================================================================================================================
                    else {
                        realOrderInfo.subtotal += itemQuantityValue;
                        realOrderInfo.iva += itemTax;
                        realOrderInfo.discount += itemDiscount;

                        if (priceListName === 'client') {
                            realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva - realOrderInfo.discount;
                        }
                        else if (priceListName === 'cost') {
                            realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva + realOrderInfo.discount;
                        }
                    }

                    // ========================================================================================================================
                    // Push data to the cart seller object
                    // ========================================================================================================================
                    itemsQuoteCartSeller.push({
                        id: item.id,
                        priceItemQuoteSeller: itemUnitValue,
                        ivaPercentageQuoteSeller: itemTaxPercent,
                        discountPercentageItemQuoteSeller: itemDiscountPercent,
                        discountValueItemQuoteSeller: itemDiscount
                    });
                }
                catch (e) {
                    let options2 = {
                        title: '',
                        isHtml: false,
                        content: e,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }

                try {
                    // Update the model
                    this.quoteCartSeller.subtotalItemsQuoteValueSeller = subtotal;
                    this.quoteCartSeller.ivaItemsQuoteValueSeller = taxes;
                    this.quoteCartSeller.discountsItemsQuoteValueSeller = discounts;
                    this.quoteCartSeller.transportItemsQuoteValueSeller = this.cart.cartTransports;
                    this.quoteCartSeller.totalItemsQuoteValueSeller = total + this.cart.cartTransports;

                    this.quoteCartSeller.realOrderInfo.transport = this.cart.cartTransports;
                    this.quoteCartSeller.realOrderInfo.total += +this.cart.cartTransports;
                    this.quoteCartSeller.realOrderInfo = realOrderInfo;

                    this.quoteCartSeller.realQuoteInfo.transport = this.cart.cartTransports;
                    this.quoteCartSeller.realQuoteInfo.total += +this.cart.cartTransports;
                    this.quoteCartSeller.realQuoteInfo = realQuoteInfo;
                    // save data state to cookie
                    this.SessionService.put('quoteCartSeller', {
                        clientPriceList: priceListName,
                        itemsQuoteCartSeller: itemsQuoteCartSeller,
                        subtotalItemsQuoteValueSeller: subtotal,
                        ivaItemsQuoteValueSeller: taxes,
                        discountsItemsQuoteValueSeller: discounts,
                        totalItemsQuoteValueSeller: this.quoteCartSeller.totalItemsQuoteValueSeller,
                        realOrderInfo: realOrderInfo,
                        realQuoteInfo: realQuoteInfo
                    });
                }
                catch (e) {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: e,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }

            });
        }
        this.updateCart();
    }

    setCurrentPointOfSale(pointOfSaleId) {
        this.pointsOfSaleData.forEach(pointOfSale => {
            if (pointOfSale.id === pointOfSaleId) {
                this.currentPointOfSale = pointOfSale;
            }
        });
    }

    savePayMethodCart(payMethodId) {
        if (payMethodId) {
            this.savingPayMethodCart = true;
            this.errorUpdatingPayMethod = false;
            let data = {
                'cartId': this.cart.cartId,
                'payMethodId': payMethodId
            };
            this.CartService.updatePayMethod(data).then(response => {
                if (!response.error) {
                    this.savingPayMethodCart = false;
                    this.updateCart();
                }
                else {
                    this.savingPayMethodCart = false;
                    this.errorUpdatingPayMethod = true;
                    this.orderDataForm.payment = '';
                }
            }).catch(reason => {
                this.savingPayMethodCart = false;
                this.errorUpdatingPayMethod = true;
            });
        }
    }

    changeLogisticService(value) {
        if (!value) {
            this.selectGuestUser();
        } else {
            this.guestUser = {};
        }
    };

    selectGuestUser() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            backdrop: 'static',
            template: modalLogistic,
            controller: 'GuestUserController',
            controllerAs: 'mdCtrl',
            resolve: {
                optionsModal: () => {
                    return this.guestUser;
                }
            }
        });
        modalInstance.result.then(resultUser => {
            this.guestUser = resultUser;
        }).catch(errModal => {
            this.isLogisticService = true;
        });
    }

    saveDiscountCoupon(code) {

        // return console.log(this.ngAuthSettings);
        if (code) {
            this.coupon.savingCoupon = true;
            this.coupon.couponSaved = false;

            const cartId = this.cart.cartId || '';
            const userId = !!(this.shCtrl.globals.currentUser) ? this.shCtrl.globals.currentUser['userId'] : '';

            if (cartId) {
                // Send the request
               // this.$timeout(() => {
                    this.CartService.saveDiscountCoupon(cartId, userId, code)
                        .then(({ data }) => {
                            
                            if(!data.error){

                                this.coupon.message = data.message;
                                this.coupon.couponSaved = true;
                                this.coupon.discountCoupon = '';
                                this.coupon.response = data;
                                this.coupon.validCoupon = !data.error;
                                this.coupon.code = code;
                                this.coupon.savingCoupon = false;
                                this.updateCart();
                
                            }else{
                                this.coupon.message = data.message;
                                this.coupon.couponSaved = false;
                                this.coupon.discountCoupon = '';
                                this.coupon.savingCoupon = false;
                                this.coupon.couponSaved = true;
                                this.validCoupon = !data.error;
                                this.couponCode = '';
                            }

                            this.$timeout( () => {
                                this.coupon.couponSaved = false;
                                this.coupon.validCoupon = false;
                            }, 5000);

                        })
                        .catch(reason => {
                            //console.log('error ' + JSON.stringify(reason));

                            this.coupon.message = "Ocurrió un error a la hora de validar el cupón de descuento, inténtalo más tarde.";

                            this.coupon.discountCoupon = '';

                            this.coupon.savingCoupon = false;
                            this.coupon.couponSaved = true;

                            this.coupon.validCoupon = false;
                            this.coupon.code = false;

                            this.$timeout(() => {
                                this.coupon.couponSaved = false;
                            }, 4000);

                        });
            }
        }
        // this.coupon.savingCoupon = true;
        // this.coupon.savedCoupon = false;
        // if (code === 'DESC14') {
        //     this.$timeout(() => {
        //         this.coupon.savingCoupon = false;
        //         this.coupon.couponSaved = true;

        //         this.coupon.validCoupon = true;
        //         this.coupon.couponValue = 10000;
        //     }, 3000);
        // }
        // else {
        //     this.$timeout(() => {
        //         this.coupon.discountCoupon = '';

        //         this.coupon.savingCoupon = false;
        //         this.coupon.couponSaved = true;

        //         this.coupon.validCoupon = false;
        //         this.coupon.couponValue = 0;
        //     }, 3000);
        // }
    }

    deleteCoupon(idCupon=0){

        this.CartService.deleteCoupon(idCupon, this.cart.cartId).then(response => {
            if (!response.data.error) {
              this.updateCart();
              this.coupon.code = '';
              this.cart.cartCoupons = '';
              this.coupon.savingCoupon = false;
              this.coupon.couponSaved = true;
              this.coupon.validCoupon = false;
              this.coupon.message = response.data.message;
            }
    
            this.$timeout( () => {
              this.coupon.couponSaved = false;
              this.coupon.validCoupon = false;
            }, 5000);
          }).catch(error => {
            this.coupon.message = "Ocurrió un error a la hora de eliminar el descuento.";
            this.coupon.discountCoupon = '';
            this.coupon.savingCoupon = false;
            this.coupon.couponSaved = true;
            this.coupon.validCoupon = false;
            this.coupon.code = false;
            this.$timeout(() => {
                this.coupon.couponSaved = false;
            }, 4000);
    
        });
    
    }

    updateCityLocation() {
        let cityLocationId = this.orderDataForm.city;
        this.updatingCityLocation = true;
        this.updatedCityLocation = false;
        this.errorUpdatingCityLocation = false;
        if (this.cart.cartId && cityLocationId) {
            this.CartService.updateCityLocation({
                'cartId': this.cart.cartId,
                'cityLocationId': cityLocationId
            }).then(response => {
                this.updatingCityLocation = false;
                this.updatedCityLocation = false;
                this.updateCart();
                if (response.error) {
                    this.errorUpdatingCityLocation = true;
                }
            }).catch(reason => {
                this.updatingCityLocation = false;
                this.updatedCityLocation = true;
                this.errorUpdatingCityLocation = true;
            });

        }
    }

    saveItemQuantity(product) {

        product.addingQuantityItemCart = true;
        this.addingQuantityItemCart = true;
        this.addedQuantityItemCart = false;
        this.errorAddingQuantityItemtoCart = false;
        this.errorMessageAddingQuantityItemtoCart = '';
        this.errorMessagesAddingQuantityItemtoCart = '';
        let quantityAmount = angular.copy(product.quantityToAddFromCart);

        if (isNaN(product.quantityToAddFromCart) || product.quantityToAddFromCart < 1) {
            product.quantityToAddFromCart = product.quantity;

        }


        let validation = this.SessionService.validateFactorItems(product.quantityToAddFromCart, product);

        if (validation.error) {

            let options = {
                title: '',
                isHtml: true,
                content: validation.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);

            product.addingQuantityItemCart = false;
            this.addingQuantityItemCart = false;
            return;
        }

        if (product.quantity !== product.quantityToAddFromCart) {
            /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al
             * usuario que hacer al respecto */
            // if (quantity > product.cantidad){
            if (product.quantityToAddFromCart > product.cantidad) {
                let userId = '';
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                }
                catch (e) {
                }
                this.CartService.updateItemsNotAvailable(product, quantityAmount, userId);

                product.addingQuantityItemCart = false;

            }

            let data = {
                'cartId': this.cart.cartId,
                'productId': product.id,
                'productQuantity': product.quantityToAddFromCart
            };

            if (this.cart.cartId) {
                this.CartService.updateQuantityItemCart(data).then(response => {
                    this.addingQuantityItemCart = false;
                    if (!response.error) {
                        this.updateCart();

                    }
                    else {
                        if (response.agotado) {
                            let userId = '';
                            try {
                                userId = this.shCtrl.globals.currentUser.userId;
                            }
                            catch (e) {
                            }
                            product.cantidad = response.itemStock;
                            this.CartService.updateItemsNotAvailable(product, product.quantityToAddFromCart, userId);
                        }


                        // let userId = '';
                        // try {
                        //   userId = this.shCtrl.globals.currentUser.userId;
                        // }
                        // catch (e) {
                        // }
                        // this.CartService.updateItemsNotAvailable(product,product.quantityToAddFromCart,userId);


                        product.quantityToAddFromCart = product.quantity;
                        this.errorAddingQuantityItemtoCart = true;
                        if (__env.adaptative) {
                            this.messageMaterial(response.message);
                        } else {
                            this.errorMessageAddingQuantityItemtoCart = response.message;
                        }

                    }
                    product.addingQuantityItemCart = false;
                }).catch(reason => {
                    this.addingQuantityItemCart = false;
                    product.addingQuantityItemCart = false;
                    product.quantityToAddFromCart = product.quantity;
                    let options = {
                        title: '',
                        isHtml: false,
                        content: 'Ha ocurrido un error al actualizar el carrito',
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }
        else {
            this.addingQuantityItemCart = false;
            product.quantityToAddFromCart = product.quantity;
            product.addingQuantityItemCart = false;
        }


    };

    createTemplate() {
        let options = {
            globals: this.shCtrl.globals
        };
        let modal_options = this.$uibModal.open({
            animation: true,
            template: modalCreateTemplate,
            controller: 'CreateTemplateModalController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modal_options.result.then(() => {

        }).catch(reason => {

        });
    }

    calcularTotales() {
        this.pesoTotalCanasta = 0;
        this.cantidadTotalCanasta = 0;
        this.cart.order.totalPesoItems = 0;
        this.cart.order.cantidadTotalCanasta = 0;
        this.cart.items.forEach(item => {
            this.pesoTotalCanasta += item.quantityToAddFromCart * item.peso.embalaje;
            this.cantidadTotalCanasta += item.quantityToAddFromCart;
            this.cart.order.totalPesoItems += item.quantityToAddFromCart * item.peso.embalaje;
            this.cart.order.cantidadTotalCanasta += item.quantityToAddFromCart;
        });
    }

    setCartSellerAction(form) {
        if (form.$valid) {
            let userIsLogged = false;
            try {
                userIsLogged = this.shCtrl.globals.currentUser.isLogged;
            }
            catch (e) {

            }
            // ===========================================================================================================
            // Logged client
            // ===========================================================================================================
            if (userIsLogged) {
                if (this.orderDataForm.quoteCartSellerAction === 'quote') {
                    this.showModalCartSeller();
                }
                else if (this.orderDataForm.quoteCartSellerAction === 'order') {

                    // If there is no client selected
                    if (this.shCtrl.globals.currentUser.userId === this.shCtrl.globals.currentUser.sellerId) {
                        this.showModalCartSeller();
                    }
                    else {
                        this.buyNow(form);
                    }
                }
            }
            else {
                this.showModalCartSeller();
            }
        }
        else {
            this.showAllCartErrors = true;

            angular.forEach(form.$error.required, field => {
                field.$setDirty();
            });
        }
    }

    showModalCartSeller() {
        // Always open the step 1

        // Validate the third number to restart all the info
        // let thirdNumberIb = $('#modalQuoteSeller #sellerQuoteAttendantDocumentNumber').val();
        // if (thirdNumberIb) {
        //   this.validateNumberIdUnused(thirdNumberIb);
        // }
    };

    openCartComment() {
        let options = {
            comment: this.orderComment
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalCartComment,
            controller: 'CommentCartModalController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(comment => {
            this.orderDataForm.comment = comment;
            this.orderComment = comment;
        }).catch(reason => {

        });
    }

    removeItemFromCart(product) {
        if (__env.adaptative) {
            var that = this;
            var confirm = this.$mdDialog.confirm()
                .title('Eliminar producto ' + product.name)
                .textContent('¿En realidad desea eliminar del carrito el producto ' + product.name + '?')
                .ok('Aceptar')
                .cancel('Cancelar');

            this.$mdDialog.show(confirm).then(function () {
                that.confirmRemoveItem(product.id, product);
            }, function () {
                console.log("cancel");
            });
        } else {
            let options = {
                title: `ELIMINAR PRODUCTO <b>${product.name}</b>`,
                isHtml: true,
                titleIsHtml: true,
                content: `¿En realidad desea eliminar del carrito el producto <b>${product.name}</b>?`,
                showBottonCancel: true,
                textActionCancel: 'Cancelar',
                textAction: 'Aceptar'
            };
            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalConfirmation,
                controller: 'ModalResponseController',
                controllerAs: 'mdCtrl',
                size: '',
                resolve: {
                    modalOptions: () => options
                }
            });
            modalInstance.result.then(() => {
                this.confirmRemoveItem(product.id, product);
            }).catch(() => {

            });
        }

    }

    confirmRemoveItem(productId, product) {
        if (this.cart.cartId) {
            this.deletingItemCart = true;
            this.deletedItemCart = false;
            this.errorDeletedItemCart = false;
            this.CartService.deleteItemFromCart(productId, this.cart.cartId).then(response => {
              console.log("este otro");
                this.deletingItemCart = false;
                if (!response.error) {
                  console.log(product);
                 this.$window.dataLayer.push({
                    'event': 'removeFromCart',
                    'ecommerce': {
                      'remove': {
                        'products': [{                        //  adding a product to a shopping cart.
                          'name': product.name,
                          'id': product.id,
                          'price':  product.currentPrice,
                           'category': product.category.slug,
                          'quantity': product.quantity
                        }]
                      }
                    }
                  });
                    this.deletedItemCart = true;
                    this.updateCart();
                    if (__env.adaptative) {
                        this.messageMaterial('El producto' + product.name + ' ha sido eliminado del carrito.')
                    } else {
                        let options = {
                            title: 'Notificación',
                            isHtml: true,
                            content: `<div class="alert alert-success" style="margin-bottom: 10px;">
              El producto <b>${product ? product.name : ''}</b> ha sido eliminado del carrito.
            </div>`,
                            size: 'sm',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }

                }
                else {
                    this.errorDeletedItemCart = true;
                }
            }).catch(error => {
                this.deletingItemCart = false;
                this.deletedItemCart = false;
                this.errorDeletedItemCart = true;
            });
        }
    }

    openMap(branch) {
        let options = {
            center: {
                latitude: branch.latitude,
                longitude: branch.longitude
            },
            zoom: 15,
            pan: true
        };
        let modal_options = this.$uibModal.open({
            animation: true,
            template: modalMap,
            controller: 'ModalMapController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modal_options.result.then(() => {

        }).catch(reason => {

        });
    }

    updateCart() {
        let cartId = this.SessionService.get('cartId') || '';
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        let clientPriceListName = '';
        try {
            clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
        } catch (e) {
        }
        this.CartService.getCart(cartId, userId, clientPriceListName, true).then(response => {

            angular.forEach(response.items, function (value, index) {
                value.quantityToAddFromCart = value.quantity;
            });
            this.cart = response;
            this.$scope.$emit('onUpdateCart');
            this.loadMethodSend = true;
            this.validateChangeTotalCartItems = true;
            this.modalidadEnvio = {};


            this.getModalidadEnvio((this.cart.cartSubtotal - this.cart.cartDiscounts + this.cart.cartTaxes));
        }).catch(reason => {
            console.log("Error al traer el carro", reason);

        })


            ;
    }


    clearCart() {
        // Delete cart
        let data = {
            'cartId': this.cart.cartId
        };
        this.CartService.clearCart(data).then(response => {
            if (!response.error) {
                this.cart = {};

                if (!this.shCtrl.globalParams.showLocationQuestion) {
                    this.SessionService.put('cartId', '');
                }

                this.SessionService.remove('quoteCartSeller');
                this.$scope.$emit('onUpdateCart');
                this.orderDataForm.comment = '';
                this.updateCart();
                this.shCtrl.scrollToTop(700);
            }
            else {
                let options = {
                    title: '',
                    isHtml: false,
                    content: response.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            }
        }).catch(reason => {
            let options = {
                title: '',
                isHtml: false,
                content: reason,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 10000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
                '  <span class="md-toast-text">' + text + '</span>\n' +
                '  <md-button ng-click="toast.closeToast()">\n' +
                '    Cerrar\n' +
                '  </md-button>\n' +
                '</md-toast>'
        });
    }
    getModalidadEnvio(total) {
        if (this.loadMethodSend == true) {
            this.loadMethodSend = false;
            this.CartService.getShippingMethod(this.cart.cartId, total).then(response => {
                this.modalidadEnvio = response;
                // angular.forEach(this.modalidadEnvio,function(value,key){
                //     if(value.id !== this.orderDataForm.shipping){
                //         this.orderDataForm.shipping = "";
                //     }
                // })
                // if(this.validateChangeTotalCartItems){
                //     this.orderDataForm.shipping = null;
                //     this.validateChangeTotalCartItems = false;
                // }
            });
        }
    }

    saveShippinMhethod(shipping) {
        // this.validateChangeTotalCartItems = false;
        let data = {
            'cartId': this.cart.cartId,
            'shipping': shipping
        };

        this.CartService.saveShipping(data).then(response => {
            this.updateCart();
        });

        this.orderDataForm.deliveryDay = "";
        this.saveDeliveryDay("");

    }
    saveWorkingHours(workingHours) {
        let data = {
            'cartId': this.cart.cartId,
            'workingHours': workingHours
        };

        this.CartService.saveWorkingHours(data).then(response => {
            this.updateCart();
        })
    }

    changeAvailableDay(shippingId) {
        this.CartService.getShippingRate(shippingId).then(response => {

            if (response.tiempo_entrega == 8) {
                let maxDay = 3;
                let dayInitials = 1;

                // if (moment().weekday() == 6) {
                //     dayInitials += 2;
                //     maxDay += 2;
                // } else

                if (moment().weekday() == 7) {
                    dayInitials += 1;
                    maxDay += 1;
                }
                let validDateMin = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                let validDateMax = moment().add(maxDay, 'days').format('YYYY-MM-DD');

                let resultadoDias = this.workingDays(validDateMin, validDateMax);

                let dayEnd = moment().add(maxDay, 'days').format('YYYY-MM-DD');
                dayEnd = new Date(dayEnd);
                if (dayEnd.getDay() != 5) {
                    if(resultadoDias == 2){
                        resultadoDias = resultadoDias - 1;
                    }
                    maxDay = maxDay + resultadoDias;
                }
                this.fechaMinima = moment().add(dayInitials, 'days').format('YYYY,MM,DD');
                this.fechaMaxima = moment().add(maxDay, 'days').format('YYYY,MM,DD');
            }
            else if (response.tiempo_entrega == 48) {
                let maxDay = 5;
                let dayInitials = 3;

                if (moment().weekday() == 6) {
                    dayInitials += 2;
                    maxDay += 2;
                } else if (moment().weekday() == 7) {
                    dayInitials += 1;
                    maxDay += 1;
                }

                let dayRangeInitials = moment().add(1, 'days').format('YYYY-MM-DD')

                let validDateMin = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                let validDateMax = moment().add(maxDay, 'days').format('YYYY-MM-DD');

                let validateRangeDaysInitials =  this.workingDays(dayRangeInitials, validDateMin);

                if(validateRangeDaysInitials > 0){
                    dayInitials = dayInitials + 1;
                    maxDay = maxDay + 1;
                    validDateMin = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                    validDateMax = moment().add(maxDay, 'days').format('YYYY-MM-DD');
                }

                let resultadoDias = this.workingDays(validDateMin, validDateMax);
                maxDay = maxDay + resultadoDias;
                let dayEnd = moment().add(maxDay, 'days').format('YYYY-MM-DD');

                dayEnd = new Date(dayEnd);
                let dayInit = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                dayInit = new Date(dayInit);

                if (dayEnd.getDay() == 6) {
                    maxDay = maxDay + 1;
                }
                this.fechaMinima = moment().add(dayInitials, 'days').format('YYYY,MM,DD');
                this.fechaMaxima = moment().add(maxDay, 'days').format('YYYY,MM,DD');
            }
            else if (response.tiempo_entrega == 78) {
                let maxDay = 6;
                let dayInitials = 4;

                if (moment().weekday() == 6) {
                    dayInitials += 2;
                    maxDay += 2;
                } else if (moment().weekday() == 7) {
                    dayInitials += 1;
                    maxDay += 1;
                }

                let dayRangeInitials = moment().add(1, 'days').format('YYYY-MM-DD')



                let validDateMin = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                let validDateMax = moment().add(maxDay, 'days').format('YYYY-MM-DD');

                let validateRangeDaysInitials =  this.workingDays(dayRangeInitials, validDateMin);

                if(validateRangeDaysInitials > 0){
                    dayInitials = dayInitials + 1;
                    maxDay = maxDay + 1;
                    validDateMin = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                    validDateMax = moment().add(maxDay, 'days').format('YYYY-MM-DD');
                }

                let resultadoDias = this.workingDays(validDateMin, validDateMax);
                maxDay = maxDay + resultadoDias;
                let dayEnd = moment().add(maxDay, 'days').format('YYYY-MM-DD');


                dayEnd = new Date(dayEnd);
                let dayInit = moment().add(dayInitials, 'days').format('YYYY-MM-DD');
                dayInit = new Date(dayInit);

                if (dayEnd.getDay() == 6) {
                    maxDay = maxDay + 1;
                }
                this.fechaMinima = moment().add(dayInitials, 'days').format('YYYY,MM,DD');
                this.fechaMaxima = moment().add(maxDay, 'days').format('YYYY,MM,DD');
            }
            this.inizializarDatePiker();
        });
    }

    workingDays(dateFrom, dateTo) {
        var inicio = new Date(dateFrom); //Fecha inicial
        var fin = new Date(dateTo); //Fecha final
        var timeDiff = Math.abs(fin.getTime() - inicio.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); //Días entre las dos fechas
        var cuentaFinde = 0; //Número de Sábados y Domingos
        var array = new Array(diffDays);
        for (var i = 0; i <= diffDays; i++) {
            // 6=> Domingo - 5 => Sábado
            if (inicio.getDay() == 6) {
                cuentaFinde++;
            }
            inicio.setDate(inicio.getDate() + 1);
        }
        return cuentaFinde;
    }

    saveDeliveryDay(date) {

      let validate =  false;
      angular.forEach(this.festive, day => {
        if(day == moment(date).format('YYYY-MM-DD')){
          this.orderDataForm.deliveryDay = "";
          let options = {
            title: '',
            isHtml: false,
            content: 'Lo sentimos, Pero no es posible la entrega para el dia que has seleccionado ya que es festivo.',
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
        };
        this.messageResponse(options);
        validate = true;
        }
    });
    if(validate){
      return
    }
        if(angular.isDefined(date) && date !=""){
        if(date.getDay() == 6 ){
            this.orderDataForm.workingHours = "am";
            this.disabledWorkingHours = true;

        }else{
            this.orderDataForm.workingHours = "";
            this.disabledWorkingHours = false;
        }
    }

        let dateFormat = "";
        if (angular.isDefined(date) && date != "") {
            dateFormat = moment(date).format('YYYY-MM-DD');
        }
        this.CartService.saveDeliveryDay(dateFormat, this.cart.cartId).then(response => {
        });
        this.saveWorkingHours(this.orderDataForm.workingHours);
    }

    open2() {
        this.popup2.opened = true;
    };

    disabled(data) {
        var date = data.date,
            mode = data.mode;
        return mode === 'day' && (date.getDay() === 0);
    };

    inizializarDatePiker() {
        this.dateOptions = {
            dateDisabled: this.disabled,
            formatYear: 'yy',
            maxDate: new Date(moment(this.fechaMaxima, 'YYYY-MM-DD').toDate()),
            minDate: new Date(moment(this.fechaMinima, 'YYYY-MM-DD').toDate()),
            startingDay: 1
        };

    }

}

CartController.$inject = inject;

export default CartController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/cart/cart.controller.js
 **/